import { EntityRequestAprv } from "../../entity/EntityRequestAprv";

export class DtoRequestAprvsPostRes extends EntityRequestAprv {}
